export default __webpack_public_path__ + "static/ombralsun-2-8a4ec0b7cccf609454fcf0ae87bde201.jpg";